import axios from "axios";
import { TCAppConfig } from "../app-configs/tc-app-configs";
import apiService from "./api-service";
 

export interface CheckAdminRequest {
  email: string;
}

export interface CheckAdminResponse {
  email: string;
  is_admin: boolean;
  message: string;
}

/**
 * Check if a user is an admin by calling the backend API
 * @param email - The user's email address
 * @param token - The authorization token
 * @returns Promise with admin check response
 */
export const checkAdminStatus = async (
  email: string,
  token: string
): Promise<{ data: CheckAdminResponse; status: number }> => {
   try {
    const response = await apiService.post<any, any>(
        `${TCAppConfig.CHECK_ADMIN_API}`,
        { email },
      );

    return { data: response.data, status: response.status };
    
  } catch (error) {
    console.error("Error checking admin status:", error);
    throw error;
  }
};
